var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgItemDelete = function SvgItemDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.179,
    d: "M4.25 5.064h-.09v10.993c0 .719.583 1.301 1.302 1.301h9.692c.719 0 1.3-.582 1.3-1.3V5.062H4.25Zm1.301 10.904V6.454h9.514v9.514z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.717,
    height: 1.39,
    x: 2.949,
    y: 5.064,
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.179,
    rx: 0.695
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.025,
    height: 1.39,
    x: 7.795,
    y: 2.641,
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.179,
    rx: 0.695
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 5.025,
    height: 1.39,
    x: 9.186,
    y: 8.699,
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.179,
    rx: 0.695,
    transform: "rotate(90 9.186 8.699)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 5.025,
    height: 1.39,
    x: 12.82,
    y: 8.699,
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 0.179,
    rx: 0.695,
    transform: "rotate(90 12.82 8.699)"
  })));
};
export default SvgItemDelete;